import { withInstall } from '@zoryn/utils'
import TimeSelect from './src/time-select.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZTimeSelect: SFCWithInstall<typeof TimeSelect> =
  withInstall(TimeSelect)
export default ZTimeSelect

export * from './src/time-select'
